import { useSelector } from "react-redux";
import Modal from "../../../../../../components/Modal/Modal";
import DeleteDocumentIcon from "../../../../../../assets/svg/delete-document-icon";
import Button from "../../../../../../components/Button/Button";
import { getFileTypeIcon } from "../../../../../../utils/functions/file-icon-extractor";
import { RootState } from "../../../../../../redux/store";
import { getRegionLabel } from "../../../../../../utils/constants/mappings";

interface DeleteDocumentModalProps {
  open: string | null;
  onOpenChange: (open: string | null) => void;
  handleDeleteDocument: () => void;
  isDeletingDocument: boolean;
  documentName?: string;
}

const DeleteDocumentModal = ({
  open,
  onOpenChange,
  handleDeleteDocument,
  isDeletingDocument,
  documentName,
}: DeleteDocumentModalProps) => {
  const clientCode = useSelector(
    (state: RootState) => state?.auth?.client?.client_code
  );
  const knowledgeBaseLabel = getRegionLabel("knowledgeBaseSection", clientCode);

  return (
    <Modal
      open={open === "deleteFromLive" || open === "deleteFromPlayground"}
      onOpenChange={(isOpen) => onOpenChange(isOpen ? open : null)}
      showHeader={true}
      contentClassName="w-[354px] border border-border-gray dark:border-border-gray-dk bg-pure-white dark:bg-pure-white-dk backdrop-blur-[10px] "
      overlayClassName="bg-black/80"
      customHeader={
        <div className="flex">
          <DeleteDocumentIcon className="w-[36px] h-[36px] text-verba-red-alert dark:text-verba-red-alert-dk" />
        </div>
      }
      headerClassName="px-6 !pb-0"
      closeButtonClassName="mb-2"
      bodyClassName="!px-6 !py-4.5"
    >
      <div className="flex flex-col gap-3">
        <h4 className="text-heading-text dark:text-heading-text-dk font-semibold text-md">
          Delete Document
        </h4>
        <p className="text-sm font-normal text-verba-field-label dark:text-verba-field-label-dk break-words">
          Are you sure you want to delete {knowledgeBaseLabel} document ‘
          <span className="font-medium text-verba-red-alert dark:text-verba-red-alert-dk">
            {documentName}
          </span>
          ’?
        </p>
        <div className="flex items-center gap-2 border border-border-gray dark:border-border-gray-dk rounded-lg p-2">
          <img
            src={getFileTypeIcon(documentName || "")}
            alt=""
            className="w-6 h-6"
          />
          <span className="text-md font-medium text-verba-indigo dark:text-verba-indigo-dk">
            {documentName}
          </span>
        </div>
        <div className="flex items-center justify-end gap-2 mt-2">
          <Button
            innerText="Cancel"
            onClick={() => onOpenChange(null)}
            buttonContainerClass="w-[110px] py-[4px] bg-verba-indigo dark:bg-verba-indigo-dk rounded-[8px] hover:bg-verba-blue dark:hover:bg-verba-blue-dk text-pure-white dark:text-pure-white-dk dark:hover:text-pure-white"
            innerTextClass="text-md font-semibold"
          />
          <Button
            innerText="Delete Document"
            onClick={handleDeleteDocument}
            isLoading={isDeletingDocument}
            buttonContainerClass="py-[4px] px-[24px] border border-verba-red-alert dark:border-verba-red-alert-dk bg-transparent dark:bg-transparent rounded-[8px] 
            hover:bg-verba-red-alert dark:hover:bg-verba-red-alert-dk hover:text-pure-white text-verba-red-alert dark:text-verba-red-alert-dk"
            innerTextClass="text-md font-semibold whitespace-nowrap"
          />
        </div>
      </div>
    </Modal>
  );
};

export default DeleteDocumentModal;
